module.exports = __webpack_public_path__ + "static/media/carosole3.623f70a7.jpg";